export default __webpack_public_path__ + "static/media/roadmap.a3c35b3f.png";